export const SUPPORTED_LOCALES = ['en', 'zh', 'th', 'hi', 'sw', 'fr']

const mapBrowserLanguage = (language: string): string | null => {
  const normalized = language.toLowerCase()

  if (normalized.startsWith('zh')) return 'zh'
  if (normalized.startsWith('en')) return 'en'
  if (normalized.startsWith('th')) return 'th'
  if (normalized.startsWith('hi')) return 'hi'
  if (normalized.startsWith('sw')) return 'sw'
  if (normalized.startsWith('fr')) return 'fr'

  return null
}

const getRegion = (language: string): string | null => {
  try {
    return new Intl.Locale(language).region || null
  } catch {
    return null
  }
}

export const resolveInitialLanguage = (saved: string | null, preferred: string | null, browserLanguages: readonly string[]): string => {
  if (saved && SUPPORTED_LOCALES.includes(saved)) return saved
  if (preferred && SUPPORTED_LOCALES.includes(preferred)) return preferred

  for (const browserLanguage of browserLanguages) {
    const mapped = mapBrowserLanguage(browserLanguage)
    if (mapped) return mapped
  }

  if (browserLanguages.some(language => ['CN', 'TW'].includes(getRegion(language) || ''))) {
    return 'zh'
  }

  return 'en'
}
